import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i2 from 'primeng/sidebar';
import { SidebarModule } from 'primeng/sidebar';
import * as i3 from 'primeng/api';
const _c0 = ["*"];
function DrawerComponent_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate);
  }
}
function DrawerComponent_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DrawerComponent_1_ng_template_0_Template, 1, 1, "ng-template", 2);
  }
}
function DrawerComponent_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.closeIconTemplate);
  }
}
function DrawerComponent_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DrawerComponent_2_ng_template_0_Template, 1, 1, "ng-template", 4);
  }
}
function DrawerComponent_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate);
  }
}
function DrawerComponent_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DrawerComponent_3_ng_template_0_Template, 1, 1, "ng-template", 5);
  }
}
function DrawerComponent_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.footerTemplate);
  }
}
function DrawerComponent_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DrawerComponent_4_ng_template_0_Template, 1, 1, "ng-template", 6);
  }
}
let DrawerComponent = /*#__PURE__*/(() => {
  class DrawerComponent {
    constructor() {
      /**
       * `isVisible` - Flag which determines whether to show the drawer or not.
       */
      this.isVisible = false;
      /**
       * `showCloseIcon` - Flag which determines whether to show the close icon on the header of drawer.
       */
      this.showCloseIcon = true;
      /**
       * `styleClass` - Class that will be appended to the class list of drawer.
       */
      this.styleClass = '';
      /**
       * `showBackdrop` - Flag which determines whether to show backdrop on the body.
       */
      this.showBackdrop = true;
      /**
       * `dismissOnBackdropClick` - Flag which determines whether to dismiss the drawer on backdrop click.
       */
      this.dismissOnBackdropClick = true;
      /**
       * `closeOnEscape` - Flag which determines whether to dismiss the on escape key press.
       */
      this.closeOnEscape = true;
      /**
       * `position` - Parameter which decides the placement of the drawer.
       */
      this.position = 'bottom';
      /**
       * `drawerTransition` - Sets the transition of the drawer.
       * Example usage: '150ms cubic-bezier(0, 0, 0.2, 1)'
       */
      this.transitionOptions = '150ms cubic-bezier(0, 0, 0.2, 1)';
      /**
       * `closeHandler` - Event emitted whenever the drawer is closed.
       */
      this.closeHandler = new EventEmitter();
      /**
       * `openHandler` - Event emitted whenever the drawer is opened.
       */
      this.openHandler = new EventEmitter();
    }
  }
  DrawerComponent.ɵfac = function DrawerComponent_Factory(t) {
    return new (t || DrawerComponent)();
  };
  DrawerComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DrawerComponent,
    selectors: [["pv-drawer"]],
    inputs: {
      isVisible: "isVisible",
      showCloseIcon: "showCloseIcon",
      style: "style",
      styleClass: "styleClass",
      showBackdrop: "showBackdrop",
      dismissOnBackdropClick: "dismissOnBackdropClick",
      closeOnEscape: "closeOnEscape",
      position: "position",
      transitionOptions: "transitionOptions",
      headerTemplate: "headerTemplate",
      contentTemplate: "contentTemplate",
      footerTemplate: "footerTemplate",
      closeIconTemplate: "closeIconTemplate"
    },
    outputs: {
      closeHandler: "closeHandler",
      openHandler: "openHandler"
    },
    ngContentSelectors: _c0,
    decls: 6,
    vars: 15,
    consts: [[3, "visibleChange", "onHide", "onShow", "visible", "position", "styleClass", "showCloseIcon", "modal", "dismissible", "closeOnEscape", "blockScroll", "transitionOptions"], [4, "ngIf"], ["pTemplate", "header"], [3, "ngTemplateOutlet"], ["pTemplate", "closeicon"], ["pTemplate", "content"], ["pTemplate", "footer"]],
    template: function DrawerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "p-sidebar", 0);
        i0.ɵɵtwoWayListener("visibleChange", function DrawerComponent_Template_p_sidebar_visibleChange_0_listener($event) {
          i0.ɵɵtwoWayBindingSet(ctx.isVisible, $event) || (ctx.isVisible = $event);
          return $event;
        });
        i0.ɵɵlistener("onHide", function DrawerComponent_Template_p_sidebar_onHide_0_listener() {
          return ctx.closeHandler.emit(false);
        })("onShow", function DrawerComponent_Template_p_sidebar_onShow_0_listener() {
          return ctx.openHandler.emit(true);
        });
        i0.ɵɵtemplate(1, DrawerComponent_1_Template, 1, 0, null, 1)(2, DrawerComponent_2_Template, 1, 0, null, 1)(3, DrawerComponent_3_Template, 1, 0, null, 1)(4, DrawerComponent_4_Template, 1, 0, null, 1);
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵstyleMap(ctx.style);
        i0.ɵɵtwoWayProperty("visible", ctx.isVisible);
        i0.ɵɵproperty("position", ctx.position)("styleClass", ctx.styleClass)("showCloseIcon", ctx.showCloseIcon)("modal", ctx.showBackdrop)("dismissible", ctx.dismissOnBackdropClick)("closeOnEscape", ctx.closeOnEscape)("blockScroll", true)("transitionOptions", ctx.transitionOptions);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.headerTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.closeIconTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.contentTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.footerTemplate);
      }
    },
    dependencies: [i1.NgIf, i1.NgTemplateOutlet, i2.Sidebar, i3.PrimeTemplate],
    styles: ["@media screen and (min-width: 962px){[_nghost-%COMP%]     .p-sidebar{width:50%!important;height:50%!important;left:50%!important;top:50%!important;transform:translate(-50%,-50%)!important}}[_nghost-%COMP%]     .p-sidebar-header:empty, [_nghost-%COMP%]     .p-sidebar-content:empty, [_nghost-%COMP%]     .p-sidebar-footer:empty{display:none}"]
  });
  return DrawerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PvDrawerModule = /*#__PURE__*/(() => {
  class PvDrawerModule {}
  PvDrawerModule.ɵfac = function PvDrawerModule_Factory(t) {
    return new (t || PvDrawerModule)();
  };
  PvDrawerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PvDrawerModule
  });
  PvDrawerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, SidebarModule]
  });
  return PvDrawerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DrawerComponent, PvDrawerModule };
